import { NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit, computed, inject } from "@angular/core";

import { MinesOption } from "@models";
import { TranslatePipe } from "@pipes";
import { ActionService, ClientService } from "@services";

import { ButtonComponent } from "../button/button.component";
import { SvgComponent } from "../svg/svg.component";

@Component({
  selector: "mn-mines-panel",
  templateUrl: "./mines-panel.component.html",
  styleUrls: ["./mines-panel.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, SvgComponent, TranslatePipe, NgTemplateOutlet],
})
export class MinesPanelComponent implements OnInit {
  private readonly acS = inject(ActionService);
  private readonly clS = inject(ClientService);

  private readonly opt = computed(() => this.acS.iS$()?.type_config?.options || []);

  protected readonly se = computed<MinesOption>(() => this.find(this.acS.mc$()?.mines_count!));
  protected readonly di = computed<boolean>(() => {
    if (this.acS.lR$()) {
      return true;
    }

    if (this.acS.wR$()) {
      return true;
    }

    if (this.acS.wP$()) {
      return true;
    }

    return !!this.acS.aR$();
  });

  public ngOnInit(): void {
    this.acS.mc$.set(this.find(this.clS.sF$().mines_count || 1));
  }

  protected select(next: number): void {
    const options = this.opt();

    const index = options.indexOf(this.se()) + next;

    if (index > options.length - 1 || index < 0) {
      return;
    }

    const option = options[index];

    this.acS.mc$.set(option);

    this.clS.set("mines_count", option.mines_count);
  }

  private find(count: number): MinesOption {
    return this.opt().find(it => it.mines_count === count)!;
  }
}
